/**
 * Tag "Beta" do Agente de Facilities.
 *
 * Use variant="gradient" em fundos brancos/claros (header, banner).
 * Use variant="onDark" em fundos coloridos/escuros (pill do botão flutuante).
 */

const GRADIENT_STYLE = {
  background: "linear-gradient(120deg, #fbdaeb 0%, #ede1ff 50%, #d6d8fb 100%)",
} as const;

interface BetaTagProps {
  /** Fundo branco para uso sobre pills coloridas; gradiente para fundos claros. */
  variant?: "gradient" | "onDark";
  className?: string;
}

export function BetaTag({ variant = "gradient", className }: BetaTagProps) {
  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-1 rounded-lg border border-[#f6f0ff] text-[10px] font-semibold text-[#2f2e29] leading-[1.2] whitespace-nowrap shrink-0 ${className ?? ""}`}
      style={variant === "onDark" ? { background: "white" } : GRADIENT_STYLE}
    >
      Beta
    </span>
  );
}
